import React from 'react'
import _ from 'lodash'

import Button from '@material-ui/core/Button';


import PrimaryButton from '../../../../../../../../../../components/Buttons/PrimaryButton';
import DocumentsFilter from "../../../../../../../../../DocumentCenter/components/DocumentsFilter";
import BaseDialog from "../../../../../../../../../../components/BaseDialog/BaseDialog";

import useStyles from './styles'


function DocumentsFilterModal(props) {
  const {
    objectType,
    bankId,
    banksData,
    open,
    activeDocuments,
    handleSwitch,
    handleConfirm
  } = props;

  const classes = useStyles();

  const [selectedDocuments, setSelectedDocuments] = React.useState([]);
  const [selectedActiveDocuments, setSelectedActiveDocuments] = React.useState([]);

  React.useEffect(() => {
    setSelectedDocuments(activeDocuments || [])
  }, [activeDocuments]);

  const onDocumentClick = (documents) => {
    let activeDocs = [...activeDocuments, ...selectedActiveDocuments];
    if (documents.length) {
      setSelectedDocuments(prevState => ([
        ...activeDocs,
        ...documents.filter(doc => !_.find(activeDocs, doc))
      ]))
    } else {
      setSelectedDocuments(activeDocs)
    }
  };
  
  const onDocumentsLoadClick = () => {
    setSelectedActiveDocuments(selectedDocuments.filter(doc => !_.find(activeDocuments, doc)))
  };

  const onDeleteDocument = (documentId) => {
    let updatedDocuments = selectedActiveDocuments.filter(doc => doc.id !== documentId)
    setSelectedActiveDocuments(updatedDocuments)
    setSelectedDocuments([...activeDocuments, ...updatedDocuments])
  };

  const onConfirmSelected = (bankId, documents) => {
    handleConfirm(bankId, documents, objectType);
    handleSwitch(bankId, objectType);
    setSelectedDocuments([]);
    setSelectedActiveDocuments([])
  };

  return (
    <>
      <BaseDialog
        open={open}
        handleClose={() => handleSwitch(bankId)}
        disableEnforceFocus
        title={'Dokument(e) hinzufügen'}
        classes={{
          root: classes.root,
          paper: classes.paper
        }}
        customClasses={{
          dialogTitle: classes.modalTitle,
        }}
        actions={
          <div className={classes.filtersRoot}>
            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              classes={{
                root: classes.loadDocsButton,
                label: classes.loadDocsButtonText,
              }}
              onClick={() => onConfirmSelected(bankId, selectedActiveDocuments.map(doc => doc.id))}
            >
              Speichern
            </Button>
          </div>
        }
      >
        <>
          <DocumentsFilter
              banksData={banksData}
              handleDocumentClick={onDocumentClick}
              handleDocumentsLoadClick={onDocumentsLoadClick}
              activeDocuments={[...activeDocuments, ...selectedActiveDocuments]}
              selectedDocuments={selectedDocuments}
              confirmButtonText={'Hinzufügen'}
          />
          <div className={classes.filtersRoot}>
            {selectedActiveDocuments.length > 0 && selectedActiveDocuments.map(doc => {
              return (
                <div className={classes.documentItem} key={doc.id}>
                  <div>
                    <span title={doc.name}>{ doc.name }</span>
                  </div>
                  <div style={{marginLeft: "auto"}}>
                    <PrimaryButton
                      text={'Entfernen'}
                      onButtonClick={() => onDeleteDocument(doc.id)}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </>
      </BaseDialog>
    </>
  );
}

export default DocumentsFilterModal
